<template>
  <section
    :data-section="`${local_data.type}_${local_data.id}`"
    class="section_p widget"
    :class="local_data.class"
  >
    <div class="container">
      <div class="widget_wrap">
        <div class="section_top">
          <div class="section_top_l">
            <div class="section_title">
              <h2 v-html="blockTitle" />
            </div>
            <nuxt-link v-if="local_data.link" :to="local_data.link" class="orange_link">
              <span>
                {{ $t('catalog.show_all_products') }}
              </span>
              <i class="arrow_right" />
            </nuxt-link>
            <div class="swiper_nav">
              <div class="small_prev">
                <img src="/icons/angle-swiper.svg" alt="prev-angle-swiper" width="17" height="17" loading="lazy">
              </div>
              <div class="small_next">
                <img src="/icons/angle-swiper.svg" alt="next-angle-swiper" width="17" height="17" loading="lazy">
              </div>
            </div>
          </div>
        </div>
        <div v-if="!loaded" class="swiper swiper_small fake">
          <div class="swiper-wrapper">
            <div v-for="item in [1,2,3,4,5]" :key="`fake_slide_${item}`" class="swiper-slide">
              <div class="product_item_wrap">
                <div class="product_item">
                  <div class="product_image_wrap">
                    <div class="product_image">
                      <img src="/loader.svg" width="200" height="200">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="swiper swiper_small">
          <div class="swiper-wrapper">
            <div v-for="item in local_data.products" :key="item.id" class="swiper-slide">
              <ProductItem :product="item" :in-carousel="true" :uniclass="`${local_data.type}_${local_data.id}_${item.id}`" />
            </div>
          </div>
        </div>
        <nuxt-link v-if="local_data.link" :to="local_data.link" class="orange_link">
          <span>
            {{ $t('catalog.show_all_products') }}
          </span>
          <i class="arrow_right" />
        </nuxt-link>
      </div>
    </div>
  </section>
</template>
<script>
import { Swiper, Navigation, Autoplay } from 'swiper'
import ProductItem from '@/components/product/ProductItem'
Swiper.use([Navigation, Autoplay])

export default {
  components: {
    ProductItem
  },
  props: {
    ext: {
      type: Object,
      default: null
    },
    lazy: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loaded: false,
      local_data: {
        title: null,
        link: null,
        banners: null,
        products: null,
        category: null,
        class: null
      }
    }
  },
  computed: {
    blockTitle () {
      return this.local_data.title
    }
  },
  created () {
    this.local_data = {
      ...this.ext
    }
  },
  mounted () {
    this.productsSliderFake()

    if (this.local_data.product_type === 'sale') {
      this.local_data.link = this.localePath('discounts') + '/'
      this.getSaleProducts()
    } else if (this.local_data.product_type === 'newest') {
      this.local_data.link = this.localePath('novelties') + '/'
      this.getNoveltiesProducts()
    } else if (this.local_data.product_type === 'viewed') {
      this.getViewedProducts()
    } else if (this.local_data.product_type === 'best_in_category') {
      this.getBestProducts(this.local_data.category.slug)
    } else {
      this.loaded = true
      setTimeout(() => {
        this.productsSlider()
      }, 500)
    }
  },
  methods: {
    getSaleProducts () {
      this.$axios.get('/api/promo/products/', { params: { catalog_type: 'sale', only_discounts: 1, per_page: 15, for_ext: 1 } }).then((res) => {
        if (res.status === 200) {
          this.loaded = true
          this.local_data.products = res.data.data
          setTimeout(() => {
            this.productsSlider()
          }, 500)
        }
      })
    },
    getNoveltiesProducts () {
      this.$axios.get('/api/promo/products/', { params: { catalog_type: 'novelty', only_new: 1, per_page: 15, for_ext: 1 } }).then((res) => {
        if (res.status === 200) {
          this.loaded = true
          this.local_data.products = res.data.data
          setTimeout(() => {
            this.productsSlider()
          }, 500)
        }
      })
    },
    getViewedProducts () {
      const viewed = String(this.$cookies.get('viewed') || '').split(',').filter(i => i !== '')
      const ids = [...new Set(viewed)].slice(0, 20)
      this.$axios.get('/api/promo/products/', { params: { ids, per_page: 15, for_ext: 1 } }).then((res) => {
        if (res.status === 200) {
          this.local_data.products = res.data.data
          if (this.local_data.products.length) {
            this.loaded = true
            setTimeout(() => {
              this.productsSlider()
            }, 500)
          }
        }
      })
    },
    getBestProducts (category) {
      this.$axios.get('/api/promo/products/', { params: { category, only_best: 1, per_page: 15, for_ext: 1 } }).then((res) => {
        if (res.status === 200) {
          this.local_data.products = res.data.data
          if (this.local_data.products.length) {
            this.loaded = true
            setTimeout(() => {
              this.productsSlider()
            }, 500)
          }
        }
      })
    },
    productsSliderFake () {
      return new Swiper(`[data-section="${this.local_data.type}_${this.local_data.id}"] .swiper.fake`, {
        slidesPerView: 'auto',
        spaceBetween: 20,
        breakpoints: {
          300: {
            slidesPerView: 'auto'
          },
          1630: {
            slidesPerView: 5
          }
        }
      })
    },
    productsSlider () {
      return new Swiper(`[data-section="${this.local_data.type}_${this.local_data.id}"] .swiper`, {
        slidesPerView: 'auto',
        spaceBetween: 20,
        autoplay: {
          delay: 3000
        },
        navigation: {
          nextEl: `[data-section="${this.local_data.type}_${this.local_data.id}"] .small_next`,
          prevEl: `[data-section="${this.local_data.type}_${this.local_data.id}"] .small_prev`
        },
        breakpoints: {
          300: {
            slidesPerView: 'auto'
          },
          1630: {
            slidesPerView: 5
          }
        }
      })
    }
  }
}
</script>
